/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgGroup,
  mtgCaption,
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputTextHalf from "components/ui/input/InputTextHalf";

/**
 * お名前
 * @param {String} sei 姓 react-hook-form管理用フォーム特定文字列
 * @param {String} mei 名 react-hook-form管理用フォーム特定文字列
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} maxLength 最大文字数
 * @param {String} txtCaption キャプション 注釈
 */
const NameKj = memo(({ sei, mei, required, maxLength, txtCaption }) => {

  // 入力チェック
  const regex = /^[^ -~｡-ﾟ\t]*$/;

  return (
    <div css={mtgGroup}>
      {/** ラベル */}
      <LabelWithOptionIcon required={required}>
        お名前
      </LabelWithOptionIcon>
      <InputTextHalf
        items={[
          {
            name: sei,
            placeholder: "姓",
            maxLength: maxLength,
            rules: {
              required: {
                value: required,
                message: "姓を入力してください。",
              },
              pattern: {
                value: regex,
                message: "利用できない文字が含まれています。",
              },
            },
          },
          {
            name: mei,
            placeholder: "名",
            maxLength: maxLength,
            rules: {
              pattern: {
                value: regex,
                message: "利用できない文字が含まれています。",
              },
            },
          },
        ]}
        isSpace={true}
        pairsValid={{
          maxSize: 10,
          message: "お名前は合計9文字以内で入力してください（姓のみの場合は10文字以内）",
        }}
      ></InputTextHalf>
      <p css={mtgCaption}>{txtCaption}</p>
    </div>
  );
});

export default NameKj;
